<div class="section-page">
  <div class="container">
    <div class="row">
      <div class="col text-center">
        <h2>Vídeos, Manuais e Treinamentos</h2>
        <p class="sub-title">Acesse conteúdos educativos em diferentes formatos para aprender como e quando quiser</p>
      </div>
    </div>
    <div class="carousel">
      <p-carousel
        [value]="items"
        [numVisible]="3"
        [numScroll]="1"
        [responsiveOptions]="responsiveOptions"
        [circular]="true"
        [autoplayInterval]="5000"
        [showNavigators]="true">
      
        <ng-template pTemplate="item" let-item>
          <a [href]="item.url" target="_blank" class="carousel-item-link">
            <div class="carousel-item-box">
              <img src="{{ item.image }}" [alt]="item.name" />
            </div>
          </a>
        </ng-template>
      </p-carousel>
    </div>
  </div>
</div>





